<template>
  <tr class="line-item">
    <td class="text-center">{{ item.id }}</td>
    <td class="text-center">{{ item.title }}</td>
    <td class="text-center">{{ item.language }}</td>
    <td class="text-center">{{ item.date }}</td>
    <td class="text-center">
      <v-icon @click="open">mdi-pencil</v-icon>
      <v-icon @click="remove">mdi-delete-forever</v-icon>
    </td>
  </tr>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'RoadmapItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      removeItem: 'settings/landing/roadmap/delete',
    }),
    open () {
      this.$router.push(`/settings/landing/roadmap/${this.item.id}`)
    },
    remove () {
      this.removeItem({ item_id: this.item.id })
        .then(() => {
          this.$emit('removed', this.item.id)
        })
    },
  },
}
</script>
<style scoped>
.line-item {
  height: 50px;
}
</style>
